import React from 'react';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms';
import { ReactComponent as Loading } from 'dist/icons/loading.svg';
import './style.scss';

interface LoadingCardProps {
  title: string;
  description: string;
  action?: React.ReactNode;
}

export const LoadingCard: React.FC<LoadingCardProps> = ({ title, description, action }) => (
  <div className="loading-card">
    <Loading />
    <div>
      <Typography.Title4 weight={TYPOGRAPHY_WEIGHT.BOLD}>{title}</Typography.Title4>
      <Typography.Text>{description}</Typography.Text>
    </div>
    {action && <div className="loading-card__action">{action}</div>}
  </div>
);
